const html = document.querySelector('html');
const popupButton = document.querySelector('.call-popup__button');
const popup = document.querySelector('.call-popup__popup');
const overlay = document.querySelector('.call-popup__overlay');
const formPopup = document.querySelector('.call-popup__form-wrapper');
const successContentPopup = document.querySelector('.call-popup__success');
const closePopupButton = document.querySelector('.call-popup__close');
const formButton = document.querySelector('.form-submit-btn-wrap button');
const successButton = document.querySelector('.call-popup__button');

// OPEN POPUP
const openPopupButton = document.querySelectorAll('[data-call-popup]');
for (var i = 0; i < openPopupButton.length; i++) {
  openPopupButton[i].addEventListener('click', function (e) {
    e.preventDefault();
    const version = this.dataset.callPopup;
    version === 'light' ? popup.classList.add('call-popup--light') : popup.classList.remove('call-popup--light');
    popup.classList.add('active');
    overlay.classList.add('active');
    html.classList.add('noscroll');
  });
}

// Change content popup on success
waitForElementToExist('.form-submit-btn-wrap button').then(element => {
  element.addEventListener('click', () => {
    waitForElementToExist('.alert.alert-success').then(elementAlert => {
      if (elementAlert) {
        formPopup.style.display = 'none';
        successContentPopup.style.display = 'block';
      }
    });
  });
});

// CLOSE POPUP 
// With the close button
closePopupButton.addEventListener('click', function () {
  popup.classList.remove('active');
  overlay.classList.remove('active');
  html.classList.remove('noscroll');
  formPopup.style.display = 'block';
  successContentPopup.style.display = 'none';
});
successButton.addEventListener('click', function () {
  popup.classList.remove('active');
  overlay.classList.remove('active');
  html.classList.remove('noscroll');
  formPopup.style.display = 'block';
  successContentPopup.style.display = 'none';
});

// With the overlay
overlay.addEventListener('click', function () {
  this.classList.remove('active');
  popup.classList.remove('active');
  html.classList.remove('noscroll');
});

// functions
function waitForElementToExist(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      subtree: true,
      childList: true
    });
  });
}